export default __webpack_public_path__ + "static/media/services-bg.82c0879b.jpg";